module.exports = __webpack_public_path__ + "static/media/IrJosephLO.452b3823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/IrJosephLO.jpg
// module id = 204
// module chunks = 0